<template>
  <img src="@/assets/copy.png" alt="Clone" class="clone_btn no-print" @click.stop="handleClick" title="Clone"/>
</template>

<script>
export default {
  name: 'CloneButton',
  methods: {
    handleClick () {
      // Emit the click event to the parent
      this.$emit('btn-clone')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.clone_btn {
  position         : absolute;
  bottom           : 1px;
  right            : 5px;
  height           : 20px;
  width            : 20px;
  cursor           : pointer;
}

</style>
